// extracted by mini-css-extract-plugin
module.exports = {"sidebar-section__title":"sidebar-section__title","sidebar-section__content":"sidebar-section__content"};